import { render, staticRenderFns } from "./SupplierManagement.vue?vue&type=template&id=cc6fef46&scoped=true"
import script from "./SupplierManagement.vue?vue&type=script&lang=js"
export * from "./SupplierManagement.vue?vue&type=script&lang=js"
import style0 from "./SupplierManagement.vue?vue&type=style&index=0&id=cc6fef46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6fef46",
  null
  
)

export default component.exports